import { put, takeEvery } from "redux-saga/effects";
import { ExportVideoInfo } from "../../models/video";
import { UpdateVideo, UpdateVideoInfoComplete } from "../actions/VideoInfoActions";
import VideoInfoApi from "../apis/VideoInfoApi";
import VideoInfoEvents from "../events/VideoInfoEvents";

// 動画出力情報更新
function* UpdateVideoInfoWorker({ updateVideoInfo }: ReturnType<typeof UpdateVideo>) {
    const exportVideoInfo: ExportVideoInfo = yield VideoInfoApi.updateVideoInfo(updateVideoInfo);
    yield put(UpdateVideoInfoComplete(exportVideoInfo));
}

export default function* VideoInfoSaga() {
    yield takeEvery(VideoInfoEvents.UpdateVideoInfoStarted, UpdateVideoInfoWorker);
}
